import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";
import { allCountryHighlightColumns } from "@utils/highLightColumnMultiCountry";

export const analyticDropdownOptions = [
  { value: "weight", label: "Total Weight", two_table_header: "Total Weight (kg)" },
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Shipment Value (USD)", two_table_header: "Total Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "Germany Imports (Mirror)",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsRangeDownloadPresent: true,
  isShipmentGridNew: true,
  isUIGridNew: true,
  isUEGridNew: true,
  isViewAllGridNew: true,
  autosuggestLang: "EN",
  isHandleTrademoAccount: false, //
  isImpExpGraph: true,
  showUiTrends: true,
  showTwoLevel: true, //
  oldPayloadType: false, //
  analyticsDefault: analyticDropdownOptions[1].value,
  isFilterGroupingPresent: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2021-01-01",
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  productChemicalKeywords: {
    "All Products": "All Products",
    "Chemicals / CAS": "Chemicals / CAS",
  },
  importer_exporter_graph_sort__options: [
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Value (USD)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("intelSearchGermanyImportLatestArrivalDate"),
    getSearchResult: getApiUrl("intelSearchGermanyImport"),
    getAnalyticsData: getApiUrl("analytics/intelAnalyticsGermanyImport"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_germany_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_germany_imports"),
    getShipmentByID: getApiUrl("intelSearchGermanyImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfGermanyImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/intelAnalyticsGermanyImportViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchGermanyImportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.de_import.country_small,
  countryCaps: globalCountryDetails.de_import.country_caps,
  product_id: globalCountryDetails.de_import.product_id,
  compare_product_id: globalCountryDetails.de_import.compareProduct,
  country_CamelCase: globalCountryDetails.de_import.product_id,
  countryCode: globalCountryDetails.de_import.countryCode,
  countryType: globalCountryDetails.de_import.countryType,
  manyCountryType: globalCountryDetails.de_import.manyCountryType,
  countryTypeCode: globalCountryDetails.de_import.countryTypeCode,
  redirectionID: globalCountryDetails.de_import.redirectionID,
  analyticsCountryID: globalCountryDetails.de_import.analyticsCountryID,
  isMirror: globalCountryDetails.de_import.continent,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.de_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortRegion",
    portOfUnlading: "standardUnladingPortRegion",
  },
  filterObj: {
    dataSource: "dataSource",
    // billOfLading: "billOfLading",
    consigneeName: "consigneeName",
    consigneeCountryRegion: "consigneeCountryRegion",
    // consigneeStateRegion: "consigneeStateRegion",
    // consigneeState: "consigneeState",
    destinationCountryRegion: "destinationCountryRegion",
    shipperName: "shipperName",
    shipperCountryRegion: "shipperCountryRegion",
    // shipperStateRegion: "shipperStateRegion",
    // shipperState: "shipperState",
    exportCountryRegion: "exportCountryRegion",
    originCountryRegion: "originCountryRegion",
    standardLadingPortRegion: "standardLadingPortRegion",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    shipmentValue: "shipmentValue",
    weight: "weight",
    hsCode: "hsCode",
    transportMode: "transportMode",
    derivedShipperMasterName: "derivedShipperMasterName",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    inboundCountry: "inboundCountry",
    inboundCountryRegion: "inboundCountryRegion",
    outboundCountry: "outboundCountry",
    outboundCountryRegion: "outboundCountryRegion",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    isImporter: "isImporter",
    isExporter: "isExporter",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  booleanFilterObj: {},
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    consigneeCountryRegion: "consigneeCountry",
    shipperCountryRegion: "shipperCountry",
    originCountryRegion: "originCountry",
    exportCountryRegion: "exportCountry",
    destinationCountryRegion: "destinationCountry",
    inboundCountryRegion: "inboundCountry",
    outboundCountryRegion: "outboundCountry",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
    standardLadingPortRegion: "standardLadingPortName",
    standardUnladingPortRegion: "standardUnladingPortName",
  },
  emptyFilterObj: {
    dataSource: [],
    consigneeName: [],
    consigneeCountryRegion: [],
    shipperName: [],
    shipperCountryRegion: [],
    originCountryRegion: [],
    exportCountryRegion: [],
    destinationCountryRegion: [],
    standardLadingPortRegion: [],
    standardUnladingPortRegion: [],
    shipmentValue: [],
    weight: [],
    hsCode: [],
    sections: [],
    transportMode: [],
    derivedShipperMasterName: [],
    derivedConsigneeMasterName: [],
    inboundCountry: [],
    inboundCountryRegion: [],
    outboundCountry: [],
    outboundCountryRegion: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    isImporter: [],
    isExporter: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    dataSource: false,
    consigneeName: false,
    consigneeCountryRegion: false,
    shipperName: false,
    shipperCountryRegion: false,
    standardLadingPortRegion: false,
    standardUnladingPortRegion: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
    shipmentValue: false,
    weight: false,
    hsCode: false,
    sections: false,
    transportMode: false,
    originCountryRegion: false,
    exportCountryRegion: false,
    destinationCountryRegion: false,
    derivedShipperMasterName: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    isImporter: false,
    isExporter: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "18", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "19", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: categoryType.shipperDetails, eventKey: "2", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search Shipper Name", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: categoryType.consigneeDetails, eventKey: "5", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search Consignee Name", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: categoryType.consigneeDetails, eventKey: "18", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search Consignee Type", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Jurisdiction Country", categoryName: categoryType.consigneeDetails, eventKey: "25", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Jurisdiction Country", categoryName: categoryType.shipperDetails, eventKey: "25", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: categoryType.shipperDetails, eventKey: "19", key: "isExporter", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search Shipper Type", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Unlading", categoryName: categoryType.ports, eventKey: "11", altKey: "standardUnladingPortName", key: "standardUnladingPortRegion", type: filterType.localizeFilter, label: "Port of Unlading", viewAllPlaceHolder: "Search Port of Unlading", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Lading", categoryName: categoryType.ports, eventKey: "12", altKey: "standardLadingPortName", key: "standardLadingPortRegion", type: filterType.localizeFilter, label: "Port of Lading", viewAllPlaceHolder: "Search Port of Lading", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "13", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Type to Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Type to Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "13", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Type to Search HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight", categoryName: categoryType.cargoDetails, eventKey: "14", key: "weight", type: filterType.boxFilter, label: "Weight", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "15", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value", viewAllPlaceHolder: "Search Shipment Value", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Conatiner Load filters you need to upgrade to higher plan.", isTextCapitalise: true },
    { heading: "Filter by Mode of Transportation", categoryName: categoryType.freightType, eventKey: "17", key: "transportMode", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search Mode of Transportation", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Mode of Transportation filters you need to upgrade to higher plan.", showInput: false },
    { heading: "Filter by Country of Import ", categoryName: categoryType.consigneeDetails, eventKey: "7", key: "inboundCountryRegion", altKey: "inboundCountry", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search Country of Import", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export ", categoryName: categoryType.shipperDetails, eventKey: "9", key: "outboundCountryRegion", altKey: "outboundCountry", type: filterType.localizeFilter, label: "Country of Export ", viewAllPlaceHolder: "Search Country of Export", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [...allCountryHighlightColumns],
  shipmentSorting: [
    { columnKey: "alias_shipment_date", value: "date", isDefault: true },
    { columnKey: "alias_derived_weight", value: "weight", isDefault: false },
    { columnKey: "alias_derived_shipment_value", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight (kg)", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  importerSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight (kg)", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  sortKeyMap: {
    date: "alias_shipment_date",
    weight: "alias_derived_weight",
    shipment_value: "alias_derived_shipment_value",
  },
  sortKeyUniqueImpExpMap: {
    date: "doc_count",
    weight: "weight",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valueSuffix: "Kg", valuePrefix: "" },
    { label: "Total Shipments Value", key: "total_value", valueSuffix: "", valuePrefix: "USD" },
  ],
  levelTwoAnalyticsHeaderItems: {},
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "outboundCountryRegion", filterKey2: "inboundCountryRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "mirror_trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false, modalHeader: "Import Trends" },
    // { key: "inbound_country", filterKey: "inboundCountryRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "port_of_lading", modalHeader: "Inbound Countries" },
    { key: "outbound_country", filterKey: "outboundCountryRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading", modalHeader: "Outbound Countries" },
    { key: "port_of_lading", filterKey: "standardLadingPortRegion", label: "Port of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading", modalHeader: "Foreign Port of Lading" },
    { key: "port_of_unlading", filterKey: "standardUnladingPortRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_lading", modalHeader: "US Ports of Unlading" },
    { key: "mode_of_transport", filterKey: "transportMode", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading" },
    { key: "", filterKey1: "", filterKey2: "", label: "Trade Routes (Shipper Country → Consignee Country)", headerOne: "Shipper Country", headerTwo: "Consignee Country", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", grpType: "multi", modalHeader: "Trade Routes(Shipper Country → Consignee State)" },
    { key: "trade_route_lading_to_unlading", filterKey1: "standardLadingPortRegion", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Port of Lading → Port of Unlading)", headerOne: "Port of Lading", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "outbound_country", grpType: "multi", modalHeader: "Trade Routes(Shipper Country → Consignee State)" },
    { key: "", filterKey1: "", filterKey2: "", label: "Trade Routes (Shipper Country → Consignee State)", headerOne: "Shipper Country", headerTwo: "Consignee State", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", grpType: "multi", modalHeader: "Trade Routes(Shipper Country → Consignee State)" },
    { key: "", filterKey1: "", filterKey2: "", label: "Trade Routes (Shipper State → Consignee Country)", headerOne: "Shipper State", headerTwo: "Consignee Country", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", grpType: "multi", modalHeader: "Trade Routes (Foreign Port of Lading → US Port of Unlading)" },
    { key: "hs_code", headerLabel: "HS Codes", filterKey: "hsCode", label: "HS Codes", type: analyticsType.hsCode, infoText: "Analytics data is based on the summary of the shipments obtained through a search query.<br/> Hence the data may contain aggregated results for all products, HS Codes present in the search results.", showlevelTwo: false, modalHeader: "2 digit HS Codes", defaultKey: "" },

    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "alias_data_source", name: "Data Source", selector: "alias_data_source", type: "dataSource", dataTip: "", grow: 0, wrap: true, miWidth: "170px", maWidth: "170px", dataSourceCountryCode: "countryCode" },
    { key: "alias_shipment_date", name: "Shipment Date", selector: "alias_shipment_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 0, wrap: true, miWidth: "92px", maWidth: "92px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "alias_derived_hs_codes", name: "HS Code", maxWidth: "120px !important", minWidth: "120px !important", selector: "alias_derived_hs_codes", wrap: true, isSliceEnabled: true, sliceLength: 40, alternateSelector: "alias_estimated_hs_codes", grow: 1, isInfoText: true, infoText: "HS Code for some shipments may be estimated based on the shipment data. For differentiation between actual and estimated HS Code please view the Shipment Details.", upgradeText: "To view estimated HS Code, you would need to upgrade to higher plan.", miWidth: "100px", maWidth: "100px" },
    { key: "alias_product_description", name: "Product", selector: "alias_product_description", tooltipValue: "alias_product_description", type: "", grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40, miWidth: "120px", maWidth: "120px" },
    { key: "alias_derived_shipper_master_name", name: "Shipper Name", selector: "alias_derived_shipper_master_name", alternateSelector: "alias_shipper_name", id: "alias_derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "alias_outbound_country", name: "Country of Export", selector: "alias_outbound_country", alternateSelector: "", id: "", dataTip: "", type: "", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px", isFirstLetterCapital: true },
    { key: "alias_derived_consignee_master_name", name: "Consignee Name", selector: "alias_derived_consignee_master_name", alternateSelector: "alias_consignee_name", id: "alias_derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "alias_inbound_country", name: "Country of Import", selector: "alias_inbound_country", alternateSelector: "", id: "", dataTip: "", type: "", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px", isFirstLetterCapital: true },
    { key: "alias_derived_weight", name: "Weight (kg)", selector: "alias_derived_weight", dataTip: "", type: "", sortable: true, grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "alias_derived_shipment_value", name: "Shipment Value (USD)", selector: "alias_derived_shipment_value", valueCheckField: "", dataTip: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view estimated shipment value, you would need to upgrade to higher plan.", miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: true, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 2, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2, grow: 1, wrap: true },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 2, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "conditionalBlur", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view Shipment, you would need to upgrade to higher plan." },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    // { key: "state", showUiUeTwoLevel: false, name: "State", selector: "state", dataTip: "", type: "", isFirstLetterCapital: true },
    // { key: "city", showUiUeTwoLevel: false, name: "City", selector: "city", dataTip: "", type: "", isFirstLetterCapital: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Date of Declaration", value: "date_of_declaration", dateFormat: true, monthFormat: false },
        { label: "Date of Arrival", value: "date_of_arrival", dateFormat: true, monthFormat: true },
        { label: "Declaration Number", value: "derived_declaration_number" },
        { label: "Item Number", value: "itemCount" },
        { label: "Item Count", value: "total_item_count", isViewAll: "is_view_all", shipmentRedirect: true, requestId: "derived_declaration_number", requestNum: "total_item_count" },
        { label: "HS Code", value: "hs_code" },
        { label: "Mode of Transportation", value: "derived_mode_of_transportation_english" },
        { label: "Incoterm", value: "derived_incoterm_code_description_combined" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Origin", value: "derived_country_of_origin_english", isCapitalise: true, tooltip: true, tooltipField: "country_of_origin_russian", countryCodeField: "originCountry", countryFlag: false },
        { label: "Country of Export", value: "derived_country_of_export", isCapitalise: false, countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        // { label: 'Place of Receipt', value: 'derived_place_of_receipt_english', tooltip: true, tooltipField: 'place_of_receipt_russian' },
        { label: "Producer Name", value: "derived_producer_name_english" },
        { label: "Producer Name (Russian)", value: "producer_name_russian" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Name", value: "derived_shipper_name_english" },
        { label: "Shipper Name (Russian)", value: "shipper_name_russian" },
        { label: "Shipper Type", value: "derived_is_exporter" },
        { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
        { label: "Shipper Address", value: "derived_shipper_address_english", isReadMore: true, readMoreLength: 45 },
        { label: "Shipper Address (Russian)", value: "shipper_address_russian", isReadMore: true, readMoreLength: 45 },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", tooltip: true, tooltipField: "country_of_destination_russian", tooltipPrefix: "Country Code: ", countryFlag: true, countryCodeField: "derived_country_of_import_code", isCapitalise: false },
        { label: "Consignee Standardized Name", value: "derived_consignee_master_name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Name", value: "derived_consignee_name_english", isCapitalise: true },
        { label: "Consignee Name (Russian)", value: "consignee_name_russian", isCapitalise: true },
        { label: "Consignee Code", value: "consignee_code" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee Address", value: "derived_consignee_address_english", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee Address (Russian)", value: "consignee_address_russian", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
        { label: "Consignee City", value: "derived_consignee_city" },
        { label: "Consignee State", value: "derived_consignee_state" },
        { label: "Consignee Pincode", value: "derived_consignee_pin_code" },
        // { label: "Consignee Country", value: "derived_consignee_country" },
      ],
    },
    {
      id: 4,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [{ label: "Type of Vehicle", value: "derived_type_of_vehicle_english", tooltip: true, tooltipField: "type_of_vehicle_russian" }],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      hideCargo: "bol",
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Russian)", value: "product_description_russian", isReadMore: true, readMoreLength: 45 },
        { label: "Product Trademark", value: "derived_product_brand_trademark_english", tooltip: true, tooltipField: "product_brand_trademark_russian" },
        { label: "Quantity", value: "quantity", unitField: "derived_quantity_unit_english", dynamicUnit: true, unitField2: "", dynamicUnit2: false, tooltip: true, tooltipField: "quantity", tooltipField2: "quantity_unit_russian" },
        { label: "Gross Weight (kg)", value: "gross_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Gross weight is the weight of the shipment measured after packaging" },
        { label: "Net Weight (kg)", value: "net_weight_kg", valueSuffix: " kg", isCommaFormat: true, infoText: "Net weight is the weight of the shipment measured after packaging" },
        { label: "Shipment Value Per Unit (USD)", value: "derived_shipment_value_usd_per_unit", valuePrefix: "USD " },
        { label: "Shipment Value (USD)", value: "shipment_value_usd", valuePrefix: "USD " },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Invoice Value (USD)", value: "derived_invoice_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "invoice_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
        { label: "Customs Value (USD)", value: "derived_customs_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "customs_value_rubles", tooltipPrefix: "RUB ", isCommaFormat: true, fixedValueUpto: 2 },
      ],
    },
    {
      id: 6,
      title: "Bill of Lading Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Total Shipment Value (USD)", valuePrefix: "USD ", value: "total_shipment_value_usd" },
        { label: "Total Invoice Value (USD)", valuePrefix: "USD ", value: "derived_total_invoice_value_usd", tooltip: true, tooltipField: "total_invoice_value_rubles", tooltipPrefix: "RUB " },
        { label: "Total Customs Value (USD)", valuePrefix: "USD ", value: "derived_total_customs_value_usd", tooltip: true, tooltipField: "total_customs_value_rubles", tooltipPrefix: "RUB " },
        { label: "Total Gross Weight (kg)", value: "derived_total_gross_weight_kg", valueSuffix: " kg" },
        { label: "Total Net Weight (kg)", value: "derived_total_net_weight_kg", valueSuffix: " kg" },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your search basis shipment arrival date", float: "", position: "left" },
    { selector: "#reacttourSearchToggle", disableInteraction: true, header: "Normal Search / Advance Search", description: "Use Advance search feature to refine your search", float: "right", position: "bottom" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for US Imports Shipments", description: "Entire Bill of Lading, HS Codes, Product Description, Buyers and Suppliers", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique consignees, shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  specialTooltipKeywords: {
    buyerZipCode: "Buyer Zip Code",
  },
  defaultUeUiSecondLevelKey: "outbound_country",
  twoColumnMapping: {
    outbound_country: "Country of Export",
    port_of_lading: "Port of Lading",
    port_of_unlading: "Port of Unlading",
    derived_shipper_master_name: "Unique Exporters",
    derived_consignee_master_name: "Unique Importers",
    mode_of_transport: "Mode of Transportation",
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    trade_route_lading_to_unlading: "Trade Routes (Port of Lading → Port of Unlading)",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const GermanyImportSearchMirror = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default GermanyImportSearchMirror;
